import { useMutation } from '@tanstack/react-query';

import * as service from '../services';
import { AderenciaBigNumbersBody } from '../types';
import { useAderenciaPrecosStore } from '../AderenciaPrecos.store';

export const useAderenciaHistory = () => {
  const { setAderenciaPrecosState } = useAderenciaPrecosStore();

  const getHistory = async (data: AderenciaBigNumbersBody) => {
    const resp = await service.getAderenciaHistory(data);
    return resp;
  };

  const successAction = data => {
    const content = data?.data ?? [];

    const percentualData = content.map(item => ({
      x: new Date(item.data).getTime(),
      y: item.produtosForaRange?.percentualForaRange || 0,
    }));

    const quantidadeData = content.map(item => ({
      x: new Date(item.data).getTime(),
      y: item.produtosForaRange?.quantidadeDataPoint || 0,
    }));

    setAderenciaPrecosState('historyPercentualForaRange', percentualData);
    setAderenciaPrecosState('historyQuantidadeDataPoint', quantidadeData);
  };

  const mutate = useMutation({
    mutationFn: getHistory,
    onSuccess: data => successAction(data),
  });

  return {
    isLoadingHistory: mutate.isPending,
    handleGetAderenciaHistoryChart: mutate.mutateAsync,
  };
};
